import React from 'react'
import PropTypes from 'prop-types'

/**
 * Toast góc trên bên phải theo mockup (xanh = thành công, đỏ = lỗi).
 */
const Toast = ({toast}) => {
    if (!toast) return null

    return <div className={`ps-toast ${toast.type === 'err' ? 'is-err' : ''}`}>{toast.text}</div>
}

Toast.propTypes = {
    toast: PropTypes.shape({
        text: PropTypes.string,
        type: PropTypes.string,
    }),
}

export default Toast
